import { LoanStatusDetails } from "../../interface/MembersPortal/ILoan";

interface CertificateFormProps {
    loanId?: string;
    loanStatusDetails: LoanStatusDetails | null;
}

function CertificateForm({ loanId, loanStatusDetails }: CertificateFormProps) {

    const middleInitial = loanStatusDetails?.middlename ? `${loanStatusDetails.middlename.charAt(0).toUpperCase()}.` : '';
    const fullName = [loanStatusDetails?.firstname, middleInitial, loanStatusDetails?.lastname].filter(Boolean).join(' ');

    const comaker1MiddleInitial = loanStatusDetails?.comakerMiddlename1 ? `${loanStatusDetails.comakerMiddlename1.charAt(0).toUpperCase()}.` : '';
    const comaker1FullName = [loanStatusDetails?.comakerFirstname1, comaker1MiddleInitial, loanStatusDetails?.comakerLastname1].filter(Boolean).join(' ');

    const comaker2MiddleInitial = loanStatusDetails?.comakerMiddlename2 ? `${loanStatusDetails.comakerMiddlename2.charAt(0).toUpperCase()}.` : '';
    const comaker2FullName = [loanStatusDetails?.comakerFirstname2, comaker2MiddleInitial, loanStatusDetails?.comakerLastname2].filter(Boolean).join(' ');

    const sigLine = (label: string) => (
        <div style={{ textAlign: 'center' }}>
            <div style={{ borderBottom: '2px solid #000', width: '240px', margin: '0 auto' }}>&nbsp;</div>
            <div style={{ fontSize: '12px', marginTop: '4px' }}>{label}</div>
        </div>
    );

    return (
        <div style={{ maxWidth: '820px', margin: '0 auto', fontFamily: 'Times New Roman, serif', fontSize: '13px', padding: '40px 48px', background: '#fff', border: '1px solid #ccc' }}>

            {/* Title */}
            <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '16px', letterSpacing: '6px', marginBottom: '28px' }}>
                CERTIFICATION
            </div>

            {/* Intro paragraph */}
            <div style={{ marginBottom: '20px', lineHeight: '1.7', textIndent: '48px' }}>
                I hereby certify that in the event that I am terminated from the service, I agree to
                the following conditions.
            </div>

            {/* Numbered conditions */}
            <ol style={{ paddingLeft: '32px', lineHeight: '1.8', marginBottom: '40px' }}>
                <li style={{ marginBottom: '10px' }}>
                    That my outstanding loans become due and demandable.
                </li>
                <li style={{ marginBottom: '10px' }}>
                    That all my salaries, bonuses, separation/gratuity pay, retirement benefits and
                    the other benefits due to me from any other source(s) shall be withheld and
                    remitted to Koopbatangan MPC to settle my outstanding loan.
                </li>
                <li style={{ marginBottom: '10px' }}>
                    <strong>
                        That if the amount collected from me is insufficient to cover my outstanding
                        obligation; my co-maker agrees to settle the balance of my loan to deduct the
                        same from his/her salary to be remitted to Koopbatangan.
                    </strong>
                </li>
            </ol>

            {/* Co-Maker / Borrower signature row */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '32px' }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ display: 'inline-block', textAlign: 'center', minWidth: '240px' }}>
                        {loanStatusDetails?.comakerSignature1 && (
                            <img src={loanStatusDetails.comakerSignature1} alt="Co-maker 1 Signature" style={{ width: '240px', height: '60px', objectFit: 'contain', display: 'block' }} />
                        )}
                        <span style={{ display: 'block', borderBottom: '2px solid #000', fontSize: '12px', padding: '0 2px' }}>
                            {comaker1FullName || ' '}
                        </span>
                    </div>
                    <div style={{ fontSize: '12px', marginTop: '4px' }}>(Co-Maker)</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ display: 'inline-block', textAlign: 'center', minWidth: '240px' }}>
                        {loanStatusDetails?.memberSignature && (
                            <img id="memberSignature" src={loanStatusDetails.memberSignature} alt="Member Signature" style={{ width: '240px', height: '60px', objectFit: 'contain', display: 'block' }} />
                        )}
                        <span style={{ display: 'block', borderBottom: '2px solid #000', fontSize: '12px', padding: '0 2px' }}>
                            {fullName || ' '}
                        </span>
                    </div>
                    <div style={{ fontSize: '12px', marginTop: '4px' }}>(Borrower)</div>
                </div>
            </div>

            {/* Second Co-Maker */}
            <div style={{ marginBottom: '32px' }}>
                <div style={{ textAlign: 'left' }}>
                    <div style={{ display: 'inline-block', textAlign: 'center', minWidth: '240px' }}>
                        {loanStatusDetails?.comakerSignature2 && (
                            <img src={loanStatusDetails.comakerSignature2} alt="Co-maker 2 Signature" style={{ width: '240px', height: '60px', objectFit: 'contain', display: 'block' }} />
                        )}
                        <span style={{ display: 'block', borderBottom: '2px solid #000', fontSize: '12px', padding: '0 2px' }}>
                            {comaker2FullName || ' '}
                        </span>
                    </div>
                    <div style={{ fontSize: '12px', marginTop: '4px' }}>(Co-Maker)</div>
                </div>
            </div>

            {/* Attested By */}
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '12px' }}>
                <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>ATTESTED BY:</div>
                <div style={{ flex: 1 }}>
                    <div style={{ borderBottom: '1px solid #000', width: '100%' }}>&nbsp;</div>
                    <div style={{ fontSize: '12px', textAlign: 'center', marginTop: '2px' }}>
                        Department Head/Officer-In-Charge/Administrative Officer
                    </div>
                </div>
            </div>

        </div>
    );
}

export default CertificateForm;
